import { initGA, trackPageView } from "@/utils/analytics";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

initGA();

/** Sends a GA4 page view on every route change. Renders nothing. */
const AnalyticsTracker = () => {
  const { pathname, search } = useLocation();

  useEffect(() => {
    trackPageView(pathname + search, document.title);
  }, [pathname, search]);

  return null;
};

export default AnalyticsTracker;
